import React from 'react'
import { useQuery } from 'react-query'

import { useWriterAction } from '@hooks/writer/useWriterAction'
import { useAuthentication } from '@hooks/useAuthentication'
import { usePagination } from '@hooks/usePagination'
import { PaymentReportProps } from './interface'

export function withPaymentReport(Component: React.FC<PaymentReportProps>) {
  function WithPaymentReport() {
    const writerClient = useWriterAction()
    const { isWriter } = useAuthentication()
    const { page, perpage, pageChange } = usePagination()

    const { data, isLoading } = useQuery(
      ['sale-report', page, perpage],
      () => writerClient.querySaleReports({ page, perpage }),
      {
        enabled: isWriter,
      }
    )

    function handlePaginationChange(newPage: number) {
      pageChange(newPage)
    }

    const componentProps = {
      datas: data?.data || [],
      isLoading,
      page,
      perpage,
      total: data?.total || 0,
      handlePaginationChange,
    }

    return <Component {...componentProps} />
  }

  return WithPaymentReport
}
